<template>
 <div style="margin: 0; position: relative;">
   <div
  v-if="isLoading"
  style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh;
         background: rgba(255, 255, 255, 0.6); z-index: 9999;
         display: flex; justify-content: center; align-items: center; flex-direction: column;"
>
 <div style="margin-bottom: 1rem; font-size: 1.2rem;">Loading...</div>
  <div class="loader-circle"></div>

</div>
<div style="margin:0">
    <vs-card style="padding: 0 !important; margin: 0 !important;">
        <vs-row style="background: linear-gradient(118deg, rgba(var(--vs-primary),1), rgba(var(--vs-primary),0.7));
              padding: 10px 12px !important;
              margin: 0 important;
              display: flex;
              align-items: center; ">
            <vs-col class="w-1/2">
             <h4 style="margin-left:14%; color:white; padding: 0;">{{ pageTitle }}</h4>
           
            </vs-col>
            <vs-col class="w-1/2">
           
                <div style="margin-left:90%">
                    <feather-icon icon="XIcon" style="color:white" class="custom-class" title="close" @click="exit"></feather-icon>
                </div>
           
            </vs-col>
        </vs-row>
    <vs-divider style="margin-top:0;"></vs-divider>
        <div style="padding-left:4%;padding-right:4%">
            <vs-row>
                <vs-alert color="danger" icon-pack="feather" icon="icon-info" v-for="(errors,err) in errorMessage" v-bind:key="err">
                    <span>{{errors}}</span>
                </vs-alert>
            </vs-row>
<vs-row style="margin-left:2%">
  <vs-col vs-lg="6" vs-sm="12" class="pr-2 pl-4 ">
     <vs-row class="mb-3" style="margin-top: 2%;">
    <vs-col>
    <vs-row class="mb-1">
         <vs-col vs-lg="3" vs-md="6" vs-sm="12" class="topPad">
        <span class="inputStyles">Receipt Number</span>
      </vs-col>
       <vs-col vs-lg="3" vs-md="6" vs-sm="12">
        <vs-input class="receiptno" readonly  v-model="receiptData.receiptNo" />
        </vs-col>
          <vs-col vs-lg="1" vs-md="2" vs-sm="2" class="p-0 " style="display: flex; align-items: center;">
            <div title="search">
              <SearchIcon  style="margin-top:5px; cursor:pointer; width:20px; height:20px;"  @click="goToreceiptDashboard" />
            </div>

          </vs-col>
             <vs-col vs-lg="1" vs-md="2" vs-sm="2" class="p-0" style="display: flex; align-items: center;margin-left: -15px;">
            <div v-if="showRefreshIcon" title="Clear">
            
           <RefreshCwIcon style="margin-top: 5px; cursor: pointer; width: 18px; height: 18px;" @click="resetForm" title="clear"/>
             </div>
          </vs-col>
    </vs-row>
         </vs-col>

     </vs-row>
      <div style="margin-top: 3%;">
         <patient-details :readonly="readonly" :patientId="patientId" :patientDetails="patientDetails" @fetchPatient="onFetchPatient"   :showSearchIcon="showSearchIcon"  source-type="receipt"></patient-details>
      </div>
    
  </vs-col>


 <vs-col vs-lg="6" vs-sm="12" class="pl-2" > 
    
                    <vs-row class="mb-3" style="margin-top: 2%;">
                        <vs-col vs-lg="3" class="topPad">
                            <span class="inputStyles">Receipt Date</span>
                        </vs-col>
                        <vs-col vs-lg="4" vs-sm="6" >
                            <vs-input readonly    :value="formatDate(receiptData.receiptDate)"  type="text" style="width:220px;"/>
                        </vs-col>
                    </vs-row>
                    <vs-row class="mb-1" style="margin-top: 4%;">
                        <vs-col vs-lg="3" class="topPad">
                            <span class="inputStyles">Note</span>
                        </vs-col>
                        <vs-col vs-lg="4" vs-sm="6"  >
                            <vs-textarea style="width: 220px;" v-model="receiptData.note" :readonly="readonlyFlag" />
                        </vs-col>
                    </vs-row>
 </vs-col>
</vs-row>
          

            

            <vs-row class="mt-2">
                <vs-col vs-lg="11" vs-sm="12">
                <table hoverFlat class="w-full ml-auto mt-4" style="padding-left:4%;padding-right:9%;padding-bottom:10%">

                    <thead>

                        <tr>

                            <th style="width:5%;text-align:center">SrNo</th>

                            <th style="width:8%;text-align:center">Type</th>

                            <th style="width:8%;text-align:center">Bill Date</th>

                            <th style="width:9%;text-align:center">Bill No</th>

                            <th style="width:10%;text-align:center">Due Amount</th>

                            <th style="width:11%;text-align:center">Collected Amount</th>

                            <th style="width:10%;text-align:center">Balance Amount</th>

                            <th style="width:10%;text-align:center">Collected Flag</th>
                          

                        </tr>

                    </thead>
                         <tbody v-if="BillDue.length==0">
            <tr>
                <td colspan="8">
                    <vs-alert active="true" color="warning" style="text-align:center">
                        <span>No Bill Dues</span>
                    </vs-alert>
                </td>
            </tr>
        </tbody>
                    <tbody>

                        <tr hoverFlat :key="index" v-for="(due, index) in BillDue" @dblclick="navigateToBill(due.billId)">

                            <td style="text-align:center">{{index+1}} </td>

                            <td>

                                <vs-input readonly class="w-full configclass" type="text" v-model="due.typeName" />

                            </td>

                            <td>

                                <vs-input readonly class="w-full configclass" type="text"    :value="formatDate(due.billDate)" />

                            </td>

                            <td>

                                <vs-input readonly class="w-full configclass" type="text" v-model="due.billId" />

                            </td>

                            <td>

                                <vs-input readonly class="w-full configclass" type="text" v-model="due.dueAmount" />

                            </td>

                            <td>

                                <vs-input @keyup="onchangeCollected(index)" :readonly="readonly" class="w-full configclass" type="text" v-model="due.collectedAmount" />

                            </td>

                            <td>

                                <vs-input readonly class="w-full configclass" type="text" v-model="due.balanceAmount" />

                            </td>

                            <td style="text-align:center">

                                <vs-checkbox class="inline-flex" v-model="due.collectedFlag" @change="onchangeFlag(index)">

                                </vs-checkbox>
                            
                            </td>

                        </tr>

                    </tbody>

                    <tfoot>

                        <tr>

                            <th style="text-align:right;padding-right:4.4%;" colspan="7">Total Due</th>

                            <td>

                                <vs-input readonly class="w-full configclass" type="text" v-model="receiptData.totalAmount" />

                            </td>

                        <tr>

                            <th style="text-align:right;padding-right:2.5%;" colspan="7">Receipt Amount</th>

                            <td>

                                <vs-input v-on:keyup="onchangeReceiptAmount" :readonly="readonly" class="w-full configclass" type="text" v-model="receiptData.receiptAmount" />

                            </td>

                        </tr>

                        <tr>

                            <th style="text-align:right;padding-right:3.2%;" colspan="7">Payment Mode</th>

                            <td>

                                <vs-select class="selectExample configclass" :disabled="readonly" v-model="receiptData.paymentMode" name="Shift">

                                    <vs-select-item :value="item.paymentId" :text="item.paymentMode" v-for="(item,index) in paymentModes" v-bind:key="index" />

                                </vs-select>

                            </td>

                        </tr>

                        <tr>

                            <th style="text-align:right;padding-right:2.3%;" colspan="7">Balance Amount</th>

                            <td>

                                <vs-input readonly class="w-full configclass" type="text" v-model="receiptData.balanceAmount" />

                            </td>

                        </tr>

                    </tfoot>

                </table>
                </vs-col>
                <vs-col vs-lg="1">
                </vs-col>

            </vs-row>

        </div>

    </vs-card>

    <vs-row>

        <vs-card class="footer" style="padding: 10px;" >

            <div class="btn-group"    style="margin-left:52%; display:flex; gap:5px; flex-wrap:wrap;">
                <vs-button :style="{ width: '100px', visibility: showDeleteButton ? 'visible' : 'hidden' }" color="danger" type="filled" @click="deleteReceipt" v-bind:disabled="deleteFlag" >Delete</vs-button>
       

                <vs-button style="width: 100px;" v-bind:disabled="saveFlag" color="success" @click="saveDue" type="filled">Save</vs-button>

                <vs-button style="width: 100px;"  v-bind:disabled="printFlag" type="gradient"  @click="print" color="primary">Print</vs-button>
                <vs-button style="width: 100px;" @click="exit" color="danger" type="filled">Exit</vs-button>
      
     

            </div>

        </vs-card>

    </vs-row>

    <vs-row>

        <print-due v-show="showDue" style="display:none;" :patientId="patientId" :BillDueData="BillDue" :receiptData="receiptData" :patientDetails="patientDetails"></print-due>

    </vs-row>

</div>
 </div>
</template>

<script>
import { SearchIcon ,RefreshCwIcon} from 'vue-feather-icons';
import PatientDetails from '../components/PatientDetails.vue';
import PrintDue from '../components/PrintDue.vue';
export default {
    components: {
        PatientDetails,
        PrintDue,
         SearchIcon,
        RefreshCwIcon
    },
    data() {
        return {
            BillDue: [{}],
            receiptData: {
                receiptNo: "New",
                receiptDate: new Date().toISOString().slice(0, 10),
                note: "",
                receiptAmount: 0,
                paymentMode: 1,

                totalAmount: 0,
                balanceAmount: 0,
                 receiptId: null, 
            },
            readonly: false,
            showDue:false,
            patientId: "",
            paymentModes: [{}],
            saveFlag: false,
            printFlag: true,
            deleteFlag:false,
            errorMessage: [],
            patientDetails: {},
             showSearchIcon:true,
              showDeleteButton: false,
              showRefreshIcon:true,
              isLoading: true,
        }
    },
computed: {
  pageTitle() {
  const { patientId, receiptNo } = this.$route.query;

  // If receiptNo exists → always Receipt
  if (receiptNo) {
    return "Receipt";
  }

  // If only patientId exists → Bill Dues
  if (patientId) {
    return "Bill Dues";
  }

  // If no parameters → Receipt
  return "Receipt";
}

},


   async created() {
   
this.isLoading= true;
try{

    this.patientId = this.$store.state.patientId || parseInt(this.$route.query.patientId) || '';
 console.log("Route query:", this.$route.query);
    
    if (this.patientId) {
       await  this.getpatientDetails();
       await this.getPaymentMode();
        this.printFlag= true;
    }

    
    if (this.$route.query.receiptNo) {
         this.showDeleteButton = true;
         this.showRefreshIcon=false
         this.showSearchIcon=false
         this.printFlag= false
          this.readonly = true;
        console.log("inside receipt",this.showDeleteButton)
       
       await this.getBillReceiptDetails(
        
            parseInt(this.$route.query.billNo),
            parseInt(this.$route.query.receiptNo)
        );
    } 

    else if (this.patientId) {
       await  this.getBillDues();
        
    }


    if (this.$store.state.patientId) {
        this.$store.dispatch('updatePatientId', '');
    }
}
catch (error) {
    console.error("Error during mounted init:", error);
  } finally {
    this.isLoading = false; 
  }
},

    methods: {
           formatDate(dateStr) {
      if (!dateStr) return "";
      const [year, month, day] = dateStr.split("-");
      return `${day}/${month}/${year}`;
    },

       async getBillReceiptDetails( billId, receiptNo) {
        try{
    const request = {
       companyId: this.$session.get('companyId'),
        billId: billId,
        receiptNo: receiptNo
    };

   const response=await this.$http.post("getBillReceiptDetails", JSON.stringify(request), {
        headers: { "Content-Type": "application/json" }
    })
        this.saveFlag=true
           
       const item = response.data.data[0]
 
        this.BillDue = response.data.data;
                    this.BillDue.forEach(element => {
                        element.typeName=element.billType
                        //element.billDate=element.billDate
                           element.billId=element.billNo
                        element.collectedFlag =element.collectedAmount>0 ;
                       //  element.dueAmountAmount = element.dueAmount;
                      //  element.balanceAmount = element.balanceAmount;
                       // element.collectedAmount = element.collectedAmount;
                        this.receiptData.totalAmount += element.dueAmount;
                          this.receiptData.balanceAmount +=element.balanceAmount;
                          this.receiptData.receiptAmount+=element.collectedAmount
                    });
                       this.receiptData.receiptNo = item.srNo;
                         this.receiptData.note=item.note;
                          this.receiptData.receiptDate=item.receiptDate
                   // this.receiptData.totalAmount = parseFloat(this.receiptData.totalAmount.toFixed(2));
                    //this.receiptData.balanceAmount = this.receiptData.totalAmount;
        }

        catch (error) {
    console.error("Error in getBillReceiptDetails:", error);
  }
    
},

        onFetchPatient(patientId) {
         console.log(" Received fetchPatient event with:", patientId);
    this.patientId = patientId;          // update parent patientId
    this.getpatientDetails();    
          this.getBillDues();
        this.getPaymentMode();       // fetch patient details
},
        
        async getpatientDetails() {
          try{
            
            var request = {
                companyId: this.$session.get('companyId'),
                regNo: this.patientId
            };
             const response=await this.$http.post(
                    "getpatiententry",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                
                
                    if (response.data && response.data.data) {
                this.patientDetails = response.data.data;
                 this.errorMessage = [];
            
            } else {
                this.patientDetails = {};
                this.$vs.notify({
                    title: 'Patient Not Found',
                    text: `No patient found with ID ${this.patientId}.`,
                    color: 'warning',
                    position: 'top-right'
                });
            }



                } catch(error) {
        console.error("Error fetching patient details:", error);
        this.patientDetails = {};
        this.$vs.notify({
            title: 'Error',
            text: 'Failed to fetch patient details. Please try again.',
            color: 'danger',
            position: 'top-right'
        });
    };
      },
 
        exit() {
    if (this.$route.query.receiptNo) {
      
        this.$router.push({ path:'/paymentCollection' });
    } else if (this.$route.query.patientId) {
     
        this.$router.push({
            path: '/patientTray',
            query: { patientId: this.$route.query.patientId }
        });
    } else {
      
        this.$router.push({ path: '/paymentCollection' }); 
       
    }
},

resetForm() {
    this.BillDue = [{}];
    this.receiptData = {
      receiptNo: "New",
      receiptDate: new Date().toISOString().slice(0, 10),
      note: "",
      receiptAmount: 0,
      paymentMode: 1,
      totalAmount: 0,
      balanceAmount: 0,
    };
    this.readonly = false;
    this.saveFlag = false;
    this.printFlag = true;
    this.errorMessage = [];
    this.patientDetails= {};
    this.patientId= " ";
  },

        navigateToBill(billId) {
              if (this.pageTitle !== "Receipt") {
            this.$router.push({
                path: 'billing',
                query: {
                    patientId: this.patientId,
                    billId: billId
                }
            })
              }
        },

           print() {
          this.showDue=true
          this.$nextTick(() => {
            setTimeout(() => {
      
        window.print();
        this.showDue = false;
            },300)
            
        },150)
        },
async getPaymentMode() {
  try {
    const response = await this.$http.post(
      "v2/getpaymentmode",
      {}, 
      {
        headers: { "Content-Type": "application/json" }
      }
    );

    this.paymentModes = response.data.data;
  } catch (error) {
    console.error("Error in getPaymentMode:", error);
  }
},

       async getBillDues() {
            var request = {
                companyId: this.$session.get('companyId'),
                patientId: this.patientId
            }

           const response= await this.$http.post(
                    "getduebills",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    })
                
                    this.BillDue = response.data.data;
                    this.BillDue.forEach(element => {
                        element.collectedFlag = false;
                        element.balanceAmount = element.dueAmount;
                        element.collectedAmount = 0;
                        this.receiptData.totalAmount += element.dueAmount;
                    });
                    this.receiptData.totalAmount = parseFloat(this.receiptData.totalAmount.toFixed(2));
                    this.receiptData.balanceAmount = this.receiptData.totalAmount;
                
        },
deleteReceipt() {
    
    this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: "Do you want to delete the receipt",
        acceptText: 'Yes, Delete',
        cancelText: 'Cancel',
        accept: () => {
            var request = {
                companyId:parseInt(this.$session.get('companyId')), 
                receiptNo:parseInt(this.receiptData.receiptNo) ,
                
            };

            this.$http.post(
                "deleteReceipt",
                JSON.stringify(request),
                {
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            )
            .then(response => {
               
                if (response.data.statusCode === 200) {
                    this.$vs.notify({
                        color: "success",
                        title: "Success",
                        text: "Receipt deleted successfully!"
                    });
                    this.deleteFlag = true;
                   this.resetForm()
                  //  this.getBillDues(); 
                } else {
                    this.$vs.notify({
                        color: "danger",
                        title: "Error",
                        text: response.data.message || "Failed to delete receipt"
                    });
                }
            }).catch(error => {
        this.$vs.notify({
          color: "warning",
          title: "API Missing",
          text: "DeleteReceipt API not available or server error!"
        });
        console.error("DeleteReceipt Error:", error);
      });
        }
    });
},

        onchangeCollected(index) {
            if (this.BillDue[index].collectedAmount) {
                if (this.BillDue[index].collectedAmount > this.BillDue[index].dueAmount || this.isNumeric(this.BillDue[index].collectedAmount) == false) {
                    this.BillDue[index].collectedAmount = this.BillDue[index].dueAmount;
                }
            };
            if (this.BillDue[index].collectedAmount <= 0) {
                this.BillDue[index].collectedFlag = false;
            } else {
                this.BillDue[index].collectedFlag = true;
            }
            this.updatebalanceAmount();
            this.showTotal();
        },

        showTotal() {
            this.receiptData.receiptAmount = 0;
            this.receiptData.balanceAmount = 0;
            this.BillDue.forEach((value) => {
                this.receiptData.receiptAmount = (this.receiptData.receiptAmount * 1) + (value.collectedAmount * 1);
                this.receiptData.balanceAmount += value.balanceAmount;
            });
            this.receiptData.receiptAmount = parseFloat(this.receiptData.receiptAmount.toFixed(2));
            this.receiptData.balanceAmount = parseFloat(this.receiptData.balanceAmount.toFixed(2));
        },
        onchangeFlag(index) {
            if (this.BillDue[index].collectedFlag == true) {
                this.BillDue[index].collectedAmount = this.BillDue[index].dueAmount;
            } else {
                this.BillDue[index].collectedAmount = 0;
            }
            this.updatebalanceAmount();
            this.showTotal();
        },

        updatebalanceAmount() {
            this.BillDue.forEach((value) => {
                value.balanceAmount = value.dueAmount - value.collectedAmount;
                value.balanceAmount = (value.balanceAmount).toFixed(2)*1

            });
        },

        onchangeReceiptAmount() {
            if (this.receiptData.receiptAmount > this.receiptData.totalAmount) {
                this.receiptData.receiptAmount = this.receiptData.totalAmount;
            }
            var receivedAmount = this.receiptData.receiptAmount;
            this.BillDue.forEach((value) => {
                value.collectedAmount = 0;
                value.collectedFlag = false;
                if (receivedAmount != 0) {
                    if (receivedAmount < value.dueAmount) {
                        value.collectedAmount = receivedAmount;
                        value.collectedFlag = true;
                        receivedAmount = 0;
                    } else {
                        value.collectedAmount = value.dueAmount;
                        value.collectedFlag = true;
                        receivedAmount = receivedAmount - value.dueAmount;
                    }
                }
            });
            this.$forceUpdate();
            this.updatebalanceAmount();
        },
        isNumeric: function (n) {

            return !isNaN(parseFloat(n)) && isFinite(n);

        },
        
            goToreceiptDashboard() {
                this.$router.push({ name: 'PaymentCollection' });
        
    },

        saveDue() {
            if (this.receiptData.receiptAmount && this.receiptData.receiptAmount > 0) {
                var request = {
                    companyId: this.$session.get('companyId'),
                    patientId: this.patientId,
                    userId: this.$session.get('userId'),
                    receiptData: this.receiptData,
                  billData: this.BillDue.filter(item => item.collectedAmount > 0)
                }
                console.log("Request payload to be sent to saveduebills:", request);
                this.$http.post(
                        "saveduebills",
                        JSON.stringify(request), {
                            headers: {
                                "Content-Type": "application/json"
                            }
                        })
                    .then(response => {
                       this.receiptData.receiptNo= response.data.data.srNo; 
                        
                        this.saveFlag = true;
                         this.printFlag= false;
                        console.log("saveflage",this.saveFlag)
                        this.printFlag = false;
                        this.readonly = true;
                        this.$vs.notify({
                            title: 'Saved Successfully',
                            color: 'success',
                            iconPack: 'feather',
                            icon: 'icon-check',

                            position: 'top-center'

                        })

                    }).catch(error => {
                        this.$vs.notify({
                            title: 'Error Occured While Saving',
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-check',
                            position: 'top-center'
                        })
                    })

            } else {
                this.errorMessage.push("Please Enter a valid Receipt Amount")
            }
        }
    },
}
</script>

<style scoped>
.receiptno {
  
  width: 100%;             
  box-sizing: border-box;  
}
.footer {

    position: fixed;

    left: 0;

    bottom: -20px;

    width: 100%;

    z-index: 500;

}

.configclass {

    width: -webkit-fill-available;

}

input[type=text] {

    text-align: center;

}

.configclass {

    width: -webkit-fill-available;

}

table th {

    text-align: center;

}

table thead {

    background: #eaeff3;

}
.inputStyles{
    font-size: 11.8px;
    font-weight: 600;
}
.topPad{
    padding-top: 7px;
}
.loader-circle {
  border: 5px solid #f3f3f3; 
  border-top: 5px solid rgb(25, 71, 170);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-top: 5px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
